import { getTranslate } from '../../utilities/i18n'
import IconTextRebrand from '../icons/IconTextRebrand'

const Recommendations = ({ recommendations }: { recommendations: number }) => {
  const { t } = getTranslate()
  return (
    <IconTextRebrand
      iconName="heart-rebrand"
      text={t('component.reviewList.recommendPlural', {
        count: recommendations,
      })}
    />
  )
}

export default Recommendations
